import { Box } from '@factorialco/deprecated-design-system'
import { A3IncidenceFinanceCostCenterAssignmentFragment } from 'generated/resources/graphql'
import { uniqBy } from 'lodash'
import moment from 'moment'

import IncidenceDetailDataChangeLine from 'modules/bookkeepers/components/IncidenceDetailDataChangeLine'

interface DataChangeInfoProps {
  costCenters: A3IncidenceFinanceCostCenterAssignmentFragment[]
}

export const CostCenterChangeInfo = ({ costCenters }: DataChangeInfoProps) => {
  const previousCostCenters: Map<number, A3IncidenceFinanceCostCenterAssignmentFragment> = new Map()
  const currentCostCenters: Map<number, A3IncidenceFinanceCostCenterAssignmentFragment> = new Map()
  const today = moment()

  costCenters.forEach((costCenter) => {
    if (costCenter.endDate && moment(costCenter.endDate).isBefore(today)) {
      previousCostCenters.set(costCenter.costCenter.id, costCenter)
    } else {
      currentCostCenters.set(costCenter.costCenter.id, costCenter)
    }
  })
  const filteredCostCenters = uniqBy(costCenters, 'cost_center_id')

  const parsePercentage = (percentage: number) => {
    return `${(percentage * 100).toFixed(0)}%`
  }

  return (
    <>
      {filteredCostCenters.map((costCenter) => {
        const currentCostCenter = currentCostCenters.get(costCenter.costCenter.id)
        const previousCostCenter = previousCostCenters.get(costCenter.costCenter.id)
        if (currentCostCenter?.percentage === previousCostCenter?.percentage) {
          return null
        }

        return (
          <Box gap="s16" key={`cost_center_change_${costCenter.costCenter.id}`}>
            <IncidenceDetailDataChangeLine
              label={costCenter.costCenter.name}
              oldValue={parsePercentage(previousCostCenter?.percentage ?? 0)}
              newValue={parsePercentage(currentCostCenter?.percentage ?? 0)}
            />
          </Box>
        )
      })}
    </>
  )
}
